import { render, staticRenderFns } from "./JSelectRole.vue?vue&type=template&id=1c32062d&scoped=true&"
import script from "./JSelectRole.vue?vue&type=script&lang=js&"
export * from "./JSelectRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32062d",
  null
  
)

export default component.exports